import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';

import {connect} from 'react-redux';
import {updateNextToolboxInd,
    updatePreviousToolboxInd,
    isNextToolboxAvailable,
    isPreviousToolboxAvailable} from '../reducers/toolbox';

import analytics from '../lib/analytics';
import BlocksButtonsComponent from '../components/blocks-buttons/blocks-buttons.jsx';

class BlocksButtons extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'onShowLessClicked',
            'onShowMoreClicked'
        ]);
    }
    onShowLessClicked () {
        this.props.onShowLessClicked();
        analytics.event({
            category: 'Palette',
            action: 'show less',
            label: window.location.hash,
            value: this.props.currentToolboxInd
        });
    }
    onShowMoreClicked () {
        this.props.onShowMoreClicked();
        analytics.event({
            category: 'Palette',
            action: 'show more',
            label: window.location.hash,
            value: this.props.currentToolboxInd
        });
    }
    render () {
        return (
            <BlocksButtonsComponent
                handleOnShowLessClicked={this.onShowLessClicked}
                handleOnShowMoreClicked={this.onShowMoreClicked}
                isShowLessActive={this.props.isShowLessActive}
                isShowMoreActive={this.props.isShowMoreActive}
                theme={this.props.theme}
            />
        );
    }
}

BlocksButtons.propTypes = {
    currentToolboxInd: PropTypes.number,
    isShowLessActive: PropTypes.bool,
    isShowMoreActive: PropTypes.bool,
    onShowLessClicked: PropTypes.func,
    onShowMoreClicked: PropTypes.func,
    theme: PropTypes.number
};

const mapStateToProps = state => ({
    currentToolboxInd: state.scratchGui.toolbox.currentToolboxInd,
    isShowMoreActive: isNextToolboxAvailable(state),
    isShowLessActive: isPreviousToolboxAvailable(state),
    theme: state.scratchGui.topicProject.theme
});

const mapDispatchToProps = dispatch => ({
    onShowMoreClicked: () => {
        dispatch(updateNextToolboxInd());
    },
    onShowLessClicked: () => {
        dispatch(updatePreviousToolboxInd());
    }
});

const ConnectedBlocksButtons = connect(
    mapStateToProps,
    mapDispatchToProps,
)(BlocksButtons);

export default ConnectedBlocksButtons;
